import { Component, Input, OnInit } from "@angular/core";
import { url } from "inspector";
import { environment } from "../../../../environments/environment";
import { ResponsiveSlideHelper } from "../../../core/_helpers";
import { SiilaTranslationService } from "../../../core/services/siila-translation.service";
import { IndustryLogo } from "../../models/industry-logo.model";

@Component({
  selector: "app-industry",
  templateUrl: "./industry-leader.component.html",
  styleUrls: ["./industry-leader.component.scss"]
})
export class IndustryLeaderComponent implements OnInit {
  @Input() resource = false;
  imageCarousel: IndustryLogo[] = [];
  imageResource: IndustryLogo[] = [];
  currentCode: string;
  slidesConfig: typeof ResponsiveSlideHelper.DEFAULT_SLIDE_CONFIG =
    ResponsiveSlideHelper.DEFAULT_SLIDE_CONFIG;
  titleResource = "";
  browserLang: string;

  constructor(private siilaTranslationSrv: SiilaTranslationService) {
    this.currentCode = environment.platformId;
    this.browserLang = this.siilaTranslationSrv.getCurrentLanguage();
    this.titleResource = this.siilaTranslationSrv.getTranslationFromJSONFiles(
      `home.${this.currentCode}.pillars.sub-title-resource`
    );

    const imgSEOPath = "imgSEO.industryLeaders.";
    this.imageCarousel = [
      {
        title: this.siilaTranslationSrv.getTranslationFromJSONFiles(
          `${imgSEOPath}capright`
        ),
        logo: `/assets/img/home-list/logo-5.png`,
        url:
          this.currentCode == "br"
            ? "https://www.capright.com/"
            : "https://www.capright.com/"
      },
      {
        title: this.siilaTranslationSrv.getTranslationFromJSONFiles(
          `${imgSEOPath}colliers`
        ),
        logo:
          this.currentCode == "br"
            ? `/assets/img/home-list/Colliers - mx-br - logo.png`
            : "/assets/img/home-list/McKinsey___Company_idXaAYJuer_1.png",
        url:
          this.currentCode == "br"
            ? "https://www.colliers.com/"
            : this.browserLang == "es"
            ? "https://www.mckinsey.com/es"
            : "https://www.mckinsey.com/"
      },
      {
        title: this.siilaTranslationSrv.getTranslationFromJSONFiles(
          `${imgSEOPath}bbva`
        ),
        logo: `/assets/img/home-list/bbva - mx-br - logo.png`,
        url:
          this.currentCode == "br"
            ? "https://www.bbva.com/"
            : "https://www.bbva.com/"
      },
      {
        title: this.siilaTranslationSrv.getTranslationFromJSONFiles(
          `${imgSEOPath}deloitte`
        ),
        logo: `/assets/img/home-list/delloite-BR-MX.png`,
        url:
          this.currentCode == "br"
            ? "https://www.deloitte.com/"
            : "https://www.deloitte.com/"
      },
      {
        title: this.siilaTranslationSrv.getTranslationFromJSONFiles(
          `${imgSEOPath}GrupoBimbo`
        ),
        logo:
          this.currentCode == "br"
            ? "/assets/img/home-list/bimbo.png"
            : `/assets/img/home-list/bimbo.png`,
        url:
          (this.currentCode == "mx" || this.currentCode == "latam") &&
          this.browserLang == "es"
            ? "https://www.grupobimbo.com/es"
            : "https://www.grupobimbo.com/en"
      },
      {
        title: this.siilaTranslationSrv.getTranslationFromJSONFiles(
          `${imgSEOPath}regus`
        ),
        logo:
          this.currentCode == "br"
            ? "/assets/img/home-list/regus-logo-BR.png"
            : "/assets/img/home-list/ernst-young.png",
        url:
          this.currentCode == "br"
            ? "https://www.regus.com/"
            : this.browserLang == "es"
            ? "https://www.ey.com/es_mx"
            : "https://www.ey.com",
        width: this.currentCode == "br" ? undefined : "80px"
      } /* ,
      {
        logo: `/assets/img/home-list/tishman-speyer-logo -BR-MX.png`,
        url:
          this.currentCode == "br"
            ? "https://tishmanspeyer.com.br"
            : "https://capright.com"
      } */
    ];

    this.imageResource = [
      {
        title: this.siilaTranslationSrv.getTranslationFromJSONFiles(
          `${imgSEOPath}valor`
        ),
        logo: `/assets/img/resource-list/Valor Economico.jpg`,
        url: "https://valor.globo.com/"
      },
      {
        title: this.siilaTranslationSrv.getTranslationFromJSONFiles(
          `${imgSEOPath}bloomberg`
        ),
        logo: `/assets/img/resource-list/Bloomberg Linea.jpg`,
        url: "https://www.bloomberglinea.com/"
      },
      {
        title: this.siilaTranslationSrv.getTranslationFromJSONFiles(
          `${imgSEOPath}elEconomista`
        ),
        logo: `/assets/img/resource-list/El Economista.jpg`,
        url: "https://www.eleconomista.com.mx/"
      },
      {
        title: this.siilaTranslationSrv.getTranslationFromJSONFiles(
          `${imgSEOPath}forbes`
        ),
        logo: `/assets/img/resource-list/Forbes.jpg`,
        url: "https://www.forbes.com/"
      },
      {
        title: this.siilaTranslationSrv.getTranslationFromJSONFiles(
          `${imgSEOPath}cnn`
        ),
        logo: `/assets/img/resource-list/CNN.jpg`,
        url: "https://www.cnn.com/"
      },
      {
        title: this.siilaTranslationSrv.getTranslationFromJSONFiles(
          `${imgSEOPath}oglobo`
        ),
        logo: `/assets/img/resource-list/Financial-Times-High-Resolution.png`,
        url: "https://www.ft.com/"
      }
    ];
  }

  ngOnInit(): void {}

  openIndustry(url: string) {
    window.open(url, "_blank");
  }
}
